/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import { Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import {
  Dimensions,
  Image,
  Platform,
  StatusBar,
  TouchableOpacity,
  useWindowDimensions,
  View,
  Clipboard,
} from "react-native"
import { style } from "./styles"
import { style as referralStyle } from "../Referral/styles"
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Carousel from "react-native-reanimated-carousel"
import { useSharedValue } from "react-native-reanimated"
import { colors } from "colors"
import { bronzeCircle } from "./helper/logo"
import { map, size } from "lodash"
import LinearGradient from "react-native-linear-gradient"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { getFCMToken } from "utils/firebase"
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context"
import { Ionicons } from "@expo/vector-icons"
import { observer } from "mobx-react-lite"
import { useColor } from "app/theme/getThemes"
import AsyncStorage from "@react-native-async-storage/async-storage"

import TierCard from "components/TierCard"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import moment from "moment"
import ReactNativeModal from "react-native-modal"

export const HomeScreen = observer(() => {
  const { companyTheme } = useColor()
  const { height } = useWindowDimensions()
  const megaphoneImage = require("assets/megaphone.png")

  const { sessionExpired } = useSessionExpired()
  const { userStore, couponStore } = useStores()
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { routeFrom }: any = route?.params || {}

  const [isModalVisible, setIsModalVisible] = useState<boolean | null>(null)
  const progressValue = useSharedValue<number>(0)
  const [point, setPoint] = useState(userStore?.totalPoint)
  const referral = userStore?.referral_code
  const voucherIcon = require("assets/voucherRedeemed.png")
  const [showInstallPrompt, setShowInstallPrompt] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [banner, setBanner] = useState([])
  const [voucher, setVoucher] = useState([])
  const [couponCoverList, setCouponCoverList] = useState("")
  const [rewardsCoverList, setRewardsCoverList] = useState("")
  const [referralRulePoint, setReferralRulePoint] = useState("")
  const [popupPromotion, setpopupPromotion] = useState({})

  const [stamps, setStamps] = useState<any>([])

  const screenWidth = Dimensions.get("screen").width
  const maxBannerWidth = 800 // Maximum width for the banner
  const bannerWidth = Math.min(screenWidth, maxBannerWidth) // Choose the smaller value between screenWidth and maxWidth
  const bannerHeight = (bannerWidth * 9) / 16 // Maintain 16:9 aspect ratio

  const maxWidth = 800
  const imageWidth = Math.min(screenWidth, maxWidth)
  const aspectRatio = 1920 / 1080

  const companyCode = process.env.COMPANY_CODE.toUpperCase()
  const referralUrl = process.env.REFERRAL_URL

  const onDisableModal = async () => {
    if (Platform.OS === "web") {
      localStorage.setItem("pop_up", "false")
    } else {
      await AsyncStorage.setItem("pop_up", "false")
    }
    setIsModalVisible(false)
  }

  // const getResponsiveWidth = useResponsiveWidth()
  // const { width } = getResponsiveWidth()
  const { width } = useWindowDimensions()

  useEffect(() => {
    navigation.setOptions({
      headerTitle: "",
      headerShown: false,
    })
  })

  useEffect(() => {
    getFCMToken(userStore?.accessToken, userStore?.id)
  }, [])

  useEffect(() => {
    // Handle PWA install prompt
    if (Platform.OS === "web") {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault()
        setDeferredPrompt(e)
        setShowInstallPrompt(true)
      })
    }
  }, [])

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      if (outcome === "accepted") {
        setDeferredPrompt(null)
        setShowInstallPrompt(false)
        console.log("User accepted the install prompt")
      } else {
        setDeferredPrompt(null)
        setShowInstallPrompt(false)
        console.log("User dismissed the install prompt")
      }
      setDeferredPrompt(null)
      setShowInstallPrompt(false)
    }
  }

  const onCloseInstallPrompt = () => {
    setShowInstallPrompt(false)
  }

  useFocusEffect(
    useCallback(() => {
      getCoupon()
      getUserPoint()
      getBanner()
      getVoucher()
      getPromotion()
      getStamp()
      getTierByUserId()
      getNotification()
      getCouponCover()
      getRewardsCover()
      getActiveReferralRule()
      return () => setPoint(0)
    }, []),
  )

  const getCoupon = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/voucher/coupon/${userStore?.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const response = await res.json()
        const coupons = Array.isArray(response) ? response : [response]

        const firstVoucherForToday = coupons.find((coupon) =>
          moment(coupon.start_date).isSame(moment(), "day"),
        )

        if (firstVoucherForToday) {
          const areIdsDifferent =
            firstVoucherForToday.voucher_catalog_id !== couponStore.newCouponNotifiedId

          if (areIdsDifferent) {
            couponStore.setShowBadge(true)
            couponStore.setNewCouponNotifiedId(firstVoucherForToday.voucher_catalog_id)
          }
        }
      } else {
        console.log("Failed to call api")
      }
    } catch (e) {
      console.error(e)
    }
  }

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data)
          // setPoint(9000)
          userStore?.update({
            totalPoint: responseData?.data,
            // totalPoint: 9000,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getPromotion = async () => {
    await fetch(`${process.env.API_URL}/api/promotion/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          const popupData = responseData?.filter((e) => {
            return e?.pop_up
          })

          if (size(popupData) === 1) {
            if (userStore?.hidePromotion !== popupData[0]?.promotion_id) {
              setIsModalVisible(true)
            }
            setpopupPromotion(popupData[0])
          }
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  const getBanner = async () => {
    await fetch(`${process.env.API_URL}/api/banner/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          const newData = responseData?.filter((a) => a.status === "active")

          const images = map(newData, (e) => {
            return e?.banner_image
          })

          setBanner(images)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getVoucher = async () => {
    const typesArray = ["cash", "active_promotion", "passive_promotion"]
    await fetch(`${process.env.API_URL}/api/voucher?types=${typesArray}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setVoucher(responseData.filter((a) => a?.status === "active"))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const [tierLevel, setTierLevel] = useState<any>([
    { currentTier: "", point: 0, nextPoint: 0, icon: null, expiry: null },
  ])
  const [tierLoading, setTierLoading] = useState(true)

  const getTierByUserId = async () => {
    try {
      // Fetch the member's tier data
      const userTierResponse = await fetch(
        `${process.env.API_URL}/api/tier/member/${userStore.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (!userTierResponse.ok) {
        const errorMsg = await userTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const userTierData = await userTierResponse.json()

      const memberTier = userTierData?.get_member_tier_info?.[0]

      if (!memberTier) return // Exit if no tier data is found

      const currentTierId = userTierData?.current_tier

      // Fetch the current tier details
      const currentTierResponse = await fetch(`${process.env.API_URL}/api/tier/${currentTierId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userStore?.accessToken}`,
        },
      })

      if (!currentTierResponse.ok) {
        const errorMsg = await currentTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const currentTierData = await currentTierResponse.json()
      // console.log("memberTier ==>", memberTier)
      // console.log("Current Tier Data ===>", currentTierData)

      const currentTierInfo = currentTierData?.[0]
      if (!currentTierInfo) return // Exit if no tier data is found

      // Combine both data sets into one state update
      setTierLevel([
        {
          point: memberTier?.sum_sales,
          nextPoint: memberTier?.next_tier_amt ?? "MAX", // Using nullish coalescing for "MAX"
          nextTier: memberTier?.next_tier_name, // Using nullish coalescing for "MAX"
          currentTier: currentTierInfo.tier_name?.toLowerCase(),
          icon: currentTierInfo.tier_image,
          expiry: userTierData.membership_expiry_date,
          allData: memberTier,
        },
      ])

      setTierLoading(false)
    } catch (error) {
      console.error("Error fetching tier data:", error)
    }
  }

  const tierColor = {
    gold: ["#FFF5B7", "#FFD700", "#FFB14E", "#D99200"],
    silver: ["#E0E0E0", "#C0C0C0", "#A9A9A9", "#D4D4D4"],
    bronze: ["#E3B778", "#CD7F32", "#D8A162", "#A76B29"],
  }

  const currentTier = tierLevel[0]?.currentTier || "white"
  const tierColors = tierColor[currentTier] || [companyTheme.first, companyTheme.second]

  const progress =
    // tierLevel[0]?.point === 0
    //   ? 0
    //   : 100 / (tierLevel[0]?.nextPoint === "MAX" ? tierLevel[0]?.point : tierLevel[0]?.nextPoint)
    (tierLevel[0]?.point === 0 ? 0 : tierLevel[0]?.point) /
      (tierLevel[0]?.nextPoint === "MAX"
        ? tierLevel[0]?.point === 0
          ? 100
          : tierLevel[0]?.point
        : tierLevel[0]?.nextPoint) || 0

  // console.log("progress =>", progress)

  // const screenWidth = Dimensions.get("screen").width
  // const maxBannerWidth = 800 // Maximum width for the banner
  // const bannerWidth = Math.min(screenWidth, maxBannerWidth) // Choose the smaller value between screenWidth and maxWidth
  // const bannerHeight = (bannerWidth * 9) / 16 // Maintain 16:9 aspect ratio

  const getStamp = async () => {
    await fetch(`${process.env.API_URL}/api/stamps/member/${userStore.id}/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          setStamps(responseData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  const [notification, setNotification] = useState<any>([])

  const getNotification = async () => {
    await fetch(`${process.env.API_URL}/api/notification/member/${userStore?.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          console.log(
            "This is notification ==>",
            responseData?.filter((a) => a.has_read === false),
          )

          setNotification(responseData?.filter((a) => a.has_read === false))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getCouponCover = async () => {
    await fetch(`${process.env.API_URL}/api/cover`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        console.log("RES: ", res)
        if (res?.ok) {
          const responseData = await res?.json()
          const newData = responseData?.filter((a) => a.name === "coupon")
          const images = map(newData, (e) => {
            return e?.image
          })
          setCouponCoverList(images[0])
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getRewardsCover = async () => {
    await fetch(`${process.env.API_URL}/api/cover`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          const newData = responseData?.filter((a) => a.name === "reward")
          const images = map(newData, (e) => {
            return e?.image
          })
          setRewardsCoverList(images[0])
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getActiveReferralRule = async () => {
    await fetch(`${process.env.API_URL}/api/referral/active`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setReferralRulePoint(responseData[0].value)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  return (
    <Screen preset="scroll" contentContainerStyle={{ paddingBottom: 30 }}>
      {/* Start Of Complicated Structure Header */}
      <View
        style={{
          width,
          backgroundColor: "transparent",
          position: "relative",
          height: 130,
          maxWidth: 800,
          zIndex: 999,
          marginTop: StatusBar.currentHeight,
        }}
      >
        <View style={style.headerBottomRightCurveContainer}>
          <LinearGradient
            style={style.headerBottomContainer}
            colors={[companyTheme.first, companyTheme.second]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View style={style.headerLeftContainer}>
                  <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <TouchableOpacity
                      onPress={() => navigation.navigate("profileStack", { screen: "profile" })}
                      style={style.headerLeft}
                    >
                      {userStore?.profileImage ? (
                        <Image
                          source={{ uri: userStore?.profileImage }}
                          style={style.profileImage}
                          resizeMode="cover"
                        />
                      ) : (
                        <>
                          <Image source={bronzeCircle} style={style.headerTierLogo} />
                          <Text style={style.headerSingleUsername}>
                            {userStore?.fullName?.charAt(0)}
                          </Text>
                        </>
                      )}
                    </TouchableOpacity>
                    <View style={{ paddingLeft: "3%" }}>
                      {/* <Text numberOfLines={1} style={[style.headerHiText, { fontSize: 12 }]}>
                        {translate("common.hi")}
                      </Text> */}
                      <Text
                        style={[
                          style.headerHiText,
                          {
                            fontWeight: "bold",
                          },
                        ]}
                        numberOfLines={2}
                        ellipsizeMode="tail"
                      >
                        {userStore?.fullName || ""}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "30%",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <TouchableOpacity
                  style={style.QRbuttonContainer}
                  onPress={() => navigation.navigate("memberQr")}
                >
                  <Ionicons name="qr-code-sharp" size={30} color="white" />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => navigation.navigate("notification")}>
                  {notification && notification.length > 0 ? (
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        position: "absolute",
                        right: 0,
                        borderRadius: 100,
                        backgroundColor: "red",
                      }}
                    />
                  ) : null}
                  <Ionicons name="notifications" size={30} color="white" />
                </TouchableOpacity>
              </View>
            </View>
            <TouchableOpacity
              style={style.pointContainer}
              onPress={() => navigation.navigate("pointHistory")}
            >
              <Text style={style.text}>{translate("redeemScreen.availablePoint")} : </Text>
              <Text style={style.text}>
                {point?.toLocaleString() || 0} {translate("redeemScreen.point")}
              </Text>
            </TouchableOpacity>
          </LinearGradient>
        </View>
      </View>

      {/* End Of Complicated Structure Header */}

      <SafeAreaProvider>
        <SafeAreaView style={[style.container, { flex: 1 }]}>
          {/* Banner */}
          {banner && banner.length > 0 ? (
            <View style={{ marginBottom: 10, paddingTop: 10, width: 800, top: -10 }}>
              <Carousel
                loop
                width={bannerWidth}
                height={bannerHeight}
                autoPlay={true}
                data={banner}
                scrollAnimationDuration={5000}
                style={{
                  width: bannerWidth,
                  height: bannerHeight,
                  maxHeight: bannerHeight,
                  minWidth: bannerWidth,
                  backgroundColor: companyTheme.first,
                }}
                modeConfig={{
                  parallaxScrollingScale: Platform.OS === "web" ? 0.89 : 2,
                  parallaxScrollingOffset: 50,
                }}
                onProgressChange={(_, absoluteProgress) => (progressValue.value = absoluteProgress)}
                renderItem={(item: any) => {
                  const imageSource =
                    Platform.OS === "web" && item?.item !== null ? item?.item : { uri: item?.item }
                  return (
                    <View
                      style={[
                        style.carouselContainer,
                        { height: bannerHeight, width: bannerWidth },
                      ]}
                    >
                      {Platform.OS === "web" ? (
                        <img src={imageSource} style={style.carouselImage} />
                      ) : (
                        <Image source={imageSource} style={style.carouselImage} />
                      )}
                    </View>
                  )
                }}
              />
            </View>
          ) : (
            <View
              style={{
                height: bannerHeight,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: colors.lighterGrey,
              }}
            >
              <Text style={{ fontSize: 16, color: "#888" }}>No banner available</Text>
            </View>
          )}
          <View>
            <Text style={{ paddingHorizontal: "2%", marginBottom: 5 }}>For You</Text>
            <TouchableOpacity onPress={() => navigation.navigate("foryou")}>
              <Image
                source={{ uri: couponCoverList }}
                resizeMode="contain"
                style={[
                  style.image,
                  {
                    width: imageWidth,
                    height: imageWidth / aspectRatio,
                  },
                ]}
              />
              <Text style={{ textAlign: "center", color: colors.lightGrey, paddingTop: 5 }}>
                More rewards for you — tap to view
              </Text>
            </TouchableOpacity>
          </View>

          {/* Tier */}
          <View style={{ paddingHorizontal: "2%", paddingTop: "2%" }}>
            <View style={[style.tierContainer, { marginBottom: 5 }]}>
              <Text>Your Current Tier</Text>
              <TouchableOpacity onPress={() => navigation.navigate("member")}>
                <Text style={[style.showAllText, { color: companyTheme.first }]}>
                  {translate("common.showAll")}
                </Text>
              </TouchableOpacity>
            </View>
            <TierCard loading={tierLoading} tierLevel={tierLevel} home={true} />
          </View>

          <View style={{ paddingTop: "2%" }}>
            <Text style={{ paddingHorizontal: "2%", marginBottom: 5 }}>Rewards</Text>
            <TouchableOpacity onPress={() => navigation.navigate("voucher")}>
              <Image
                source={{ uri: rewardsCoverList }}
                resizeMode="contain"
                style={[
                  style.image,
                  {
                    width: imageWidth,
                    height: imageWidth / aspectRatio,
                  },
                ]}
              />
              <Text style={{ textAlign: "center", color: colors.lightGrey, paddingTop: 5 }}>
                Tap to view your current rewards
              </Text>
            </TouchableOpacity>
          </View>

          <View style={{ paddingTop: "2%" }}>
            <Text style={{ paddingHorizontal: "2%", marginBottom: 5 }}>Referral</Text>
            <View style={{ backgroundColor: companyTheme.second }}>
              <View style={referralStyle.container}>
                <Image source={megaphoneImage} style={referralStyle.megaphoneImage} />
                <View style={referralStyle.contentContainer}>
                  <Text style={referralStyle.contentTitle}>
                    {translate("referralScreen.inviteFriend")}
                  </Text>
                  <Text>
                    {translate("referralScreen.earn")}{" "}
                    <Text style={{ color: companyTheme.first }}>
                      {referralRulePoint} {translate("referralScreen.point")}
                    </Text>{" "}
                    {translate("referralScreen.eachFriend")}
                  </Text>

                  <View style={referralStyle.referralCodeContainer}>
                    <Text>{translate("referralScreen.yourRefferal")}</Text>
                    <View style={referralStyle.referralCodeWrapper}>
                      <Text style={referralStyle.referralCodeText}>{referral}</Text>
                      <MaterialIcons
                        onPress={() => {
                          flash("success", translate("referralScreen.copiedToClipboard"))
                          Clipboard.setString(
                            `Invite your friend to join ${companyCode} app and get rewarded\nYour referral code: ${referral}\n${referralUrl}/register/${referral}`,
                          )
                        }}
                        name="content-copy"
                        size={20}
                        color={companyTheme.first}
                      />
                    </View>
                  </View>
                </View>
              </View>
              <View style={referralStyle.ball1} />
              <View style={referralStyle.ball2} />
              <View style={referralStyle.ball3} />
              <View style={referralStyle.ball4} />
              <View style={referralStyle.ball5} />
              <View style={referralStyle.ball6} />
              <View style={referralStyle.ball7} />
              <View style={referralStyle.ball8} />
            </View>
          </View>
        </SafeAreaView>
      </SafeAreaProvider>
      <ReactNativeModal
        isVisible={isModalVisible}
        style={{ flex: 1, justifyContent: "center" }}
        onBackButtonPress={() => {
          userStore?.update({ hidePromotion: popupPromotion?.promotion_id })
          setIsModalVisible(false)
        }}
        onBackdropPress={() => {
          userStore?.update({ hidePromotion: popupPromotion?.promotion_id })
          setIsModalVisible(false)
        }}
      >
        <View>
          <TouchableOpacity
            onPress={() => {
              setIsModalVisible(false)
              userStore?.update({ hidePromotion: popupPromotion?.promotion_id })
              navigation.navigate("promotionDetail", { promotion_id: popupPromotion?.promotion_id })
            }}
          >
            <Image
              resizeMode="cover"
              style={{ height: screenWidth - 45, width: screenWidth - 45 }}
              source={{ uri: popupPromotion?.promotion_banner }}
            ></Image>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              setIsModalVisible(false)
              userStore?.update({ hidePromotion: popupPromotion?.promotion_id })
            }}
          >
            <Text style={style.hidePopUpText}>Do not show again</Text>
          </TouchableOpacity>
        </View>
      </ReactNativeModal>
    </Screen>
  )
})
